import { useQuery } from '@tanstack/react-query';
import { BarChart3 } from 'lucide-react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { apiClient } from '@/lib/api-client';
import { CardShell } from '../cards/card-shell';

/**
 * Bar chart com 3 barras: Pendentes / Atrasadas / Resolvidas no mes.
 * Usa apiClient.tasksStatsSummary que ja retorna os 3 valores.
 */
export function ActivityChartWidget() {
  const { data, isLoading } = useQuery({
    queryKey: ['tasks', 'summary'],
    queryFn: () => apiClient.tasksStatsSummary(),
    staleTime: 1000 * 60,
  });

  const rows = [
    { label: 'Pendentes', value: data?.totalPending ?? 0 },
    { label: 'Atrasadas', value: data?.totalOverdue ?? 0 },
    { label: 'Resolvidas', value: data?.completedThisMonth ?? 0 },
  ];

  return (
    <CardShell title="Atividade" icon={BarChart3}>
      <div className="h-full w-full">
        {isLoading ? (
          <div className="h-full w-full animate-pulse rounded bg-[var(--surface-muted)]/40" />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={rows}
              margin={{ top: 8, right: 8, left: -20, bottom: 0 }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="var(--border)"
                vertical={false}
              />
              <XAxis
                dataKey="label"
                stroke="var(--fg-muted)"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="var(--fg-muted)"
                fontSize={10}
                tickLine={false}
                axisLine={false}
                allowDecimals={false}
              />
              <Tooltip
                cursor={{ fill: 'var(--surface-muted)', opacity: 0.4 }}
                contentStyle={{
                  background: 'var(--surface)',
                  border: '1px solid var(--border)',
                  borderRadius: 8,
                  fontSize: 12,
                  color: 'var(--fg)',
                }}
                labelStyle={{ color: 'var(--fg)' }}
                itemStyle={{ color: 'var(--fg)' }}
              />
              <Bar
                dataKey="value"
                name="Tarefas"
                fill="#3b82f6"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </CardShell>
  );
}
